import {AsyncContainerModule, interfaces} from "inversify";
import {cabinetCustomerTypes} from "./types";

export default new AsyncContainerModule(async (bind: interfaces.Bind, unbind: interfaces.Unbind) => {

});
